exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-profile-api-key-management-___styles__container___1LHOr {\n  display: flex;\n  justify-content: center;\n  flex: 1;\n}\n\n.src-components-profile-api-key-management-___styles__container___1LHOr table {\n  width: 550px;\n}\n\n.src-components-profile-api-key-management-___styles__container___1LHOr table td {\n  padding: 12px 0;\n  border-bottom: 1px solid #d0d0d0;\n}\n\n.src-components-profile-api-key-management-___styles__container___1LHOr .src-components-profile-api-key-management-___styles__delete___2n8vh {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.src-components-profile-api-key-management-___styles__container___1LHOr .src-components-profile-api-key-management-___styles__delete___2n8vh i {\n  cursor: pointer;\n}", ""]);

// exports
exports.locals = {
	"container": "src-components-profile-api-key-management-___styles__container___1LHOr",
	"delete": "src-components-profile-api-key-management-___styles__delete___2n8vh"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/profile/api-key-management/styles.scss
// module id = 2461
// module chunks = 0